import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Modal, Col, Row } from 'react-bootstrap';
import { Toast } from 'primereact/toast';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { message } from '../shared/Message';
import useToast from '../shared/hooks/useToast';
import Loading from "../shared/Loading";
import api from '../../scripts/api';
import { getClientForm } from '../../scripts/api/clientFormApi';

function ExternalFormSubmissions() {
  const [listData, setListData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { toast, successToast } = useToast();

  const handleCopyExternalFormLinkClick = () => {
    getClientForm().then(result => {
      const origin = window.location.origin;
      const url = `${origin}/client/newclientintakeform/${result.externalId}`

      navigator.clipboard.writeText(url);
      successToast("Link copied to clipboard")
    }).catch(err => {
      message.error(`Problem copying external form link: ${err.message}`);
    });
  };

  const handleRowClick = (event) => {
    const { id } = event.data;
    navigate(`/Client/${id}`);
  };

  const additionalInformationClick = () => {
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
  }

  useEffect(() => {
    api.getAllPendingClientsForUser().then(result => {
      setListData(result);
    }).catch(err => {
      message.error(`Problem retrieving clients who need approval: ${err.message}`);
    });
  }, []);

  return (
    <React.Fragment>
      <Row className="mb-3">
        Share the following link with Clients to allow them to fill out their own intake forms without requiring an account.        
      </Row>         

      <Row className="mb-3">
        <ButtonGroup>
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleCopyExternalFormLinkClick()}>
            Copy Form Link
          </Button>
          <Button
            variant="outline-info"
            size="sm"
            onClick={additionalInformationClick}>
            Additional Information
          </Button>
        </ButtonGroup>
        
      </Row>
      
      <h1>Submissions Pending Review</h1>

      <Row>
        {listData === null 
          ? <Loading data={"Clients"} />
          : (
            <DataTable
              value={listData.allClients}
              className="client-data-table"
              stripedRows
              rows={10}
              emptyMessage="No clients found"
              onRowClick={(e) => handleRowClick(e)}
              sortField="id"
              sortOrder={-1}
            >
              <Column field="firstName" header="First Name" />
              <Column field="lastName" header="Last Name" />
              <Column field="dateOfBirth" header="DOB" />
              <Column field="createdDate" header="Form Submitted" />
            </DataTable>
          )
        }
      </Row>
      <Modal
        show={showModal}
        centered
        dialogClassName="modal--confirmation"
        onHide={handleHideModal}
      >
        <div className="p-4">
          <h1>Preserving Client Confidentiality</h1>

          <p>
            In order to protect Client privacy, there are a couple changes in how the external form works when compared to how an authenticated user would use the form.
          </p>

          <h2>Duplicate Clients</h2>           

          <p>Submitting the external form will not validate whether a client with the same first name, last name, and date of birth already exists in the system.</p>

          <p>Instead, you will receive a "duplicate client" error if you try to approve an external submission and that client already exists in your organization.</p>

          <h2>Adding Related Clients</h2>

          <p>The "Add Relationships" module will be disabled when the form is accessed by an unauthenticated user.</p>

          <Row className="text-center">
            <Col>
              <Button
                onClick={handleHideModal}
              >
                OK
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
      <Toast ref={toast} position="bottom-left" />
    </React.Fragment>
  );
}

export default ExternalFormSubmissions;
